
import axios from 'axios';
import { computed } from 'vue';
import {usePortalContentAndDesignStore} from "../../stores/partners/portalContentAndDesignStore";

export function useLogin() {

    const portalContentAndDesignStore = usePortalContentAndDesignStore();

    const getFormActionRoute = computed(() => {
        return portalContentAndDesignStore.loginPageSettings.is_otp_login
            ? route('partners_int.portal-login.otp.ini')
            : route('partners_int.portal-login.standard.login');
    });

    const recaptchaEnabled = computed(() => portalContentAndDesignStore.recaptchaSettings?.portal_recaptcha_enabled);
    const recaptchaKey = computed(() => portalContentAndDesignStore.recaptchaSettings?.portal_recaptcha_site_key);

    const resetLoginErrors = () => {
        portalContentAndDesignStore.resetFormErrors('login');
    };

    const standardLogin = (recaptchaToken = null) => {
        resetLoginErrors();
        portalContentAndDesignStore.loggingInProgress = true;

        const payload = {
            email: portalContentAndDesignStore.loginFormData.email,
            password: portalContentAndDesignStore.loginFormData.password,
        };

        if (recaptchaToken) {
            payload['g-recaptcha-response'] = recaptchaToken;
        }

        axios.post(getFormActionRoute.value, payload)
            .then(response => {
                if (+response.data.status === 1) {
                    resetLoginErrors();
                    window.location.href = response.data.redirect_url;
                } else {
                    portalContentAndDesignStore.loginFormErrors.responseError = response.data?.error;
                    portalContentAndDesignStore.loginFormData.password = '';
                    document.getElementById('password')?.focus();
                }
            }).catch(error => {
            if (error.response && error.response.status === 422) {
                portalContentAndDesignStore.loginFormErrors.validationErrors = error.response?.data?.errors;
            } else {
                console.log('Login error:', error.response);
                portalContentAndDesignStore.loginFormErrors.responseError = error.response?.data?.error || 'An error occurred. See console for details.';
            }

            })
            .finally(() => {
                portalContentAndDesignStore.loggingInProgress = false;
            });
        };

    const initOtp = (recaptchaToken = null) => {
        resetLoginErrors();
        portalContentAndDesignStore.loggingInProgress = true;

        const payload = {
            email: portalContentAndDesignStore.loginFormData.email,
        };

        if (recaptchaToken) {
            payload['g-recaptcha-response'] = recaptchaToken;
        }

        axios.post(getFormActionRoute.value, payload)
            .then(response => {
                if (+response.data.status === 1) {
                    resetLoginErrors();
                    portalContentAndDesignStore.loginFormData.otpIdentifier = response.data.otp_identifier;
                    portalContentAndDesignStore.loginFormData.otpIniSuccessMessage = response.data.otp_message;
                } else {
                    portalContentAndDesignStore.loginFormErrors.responseError = response.data?.error;
                    portalContentAndDesignStore.loginFormData.password = '';
                    document.getElementById('password')?.focus();
                }
            }).catch(error => {
                if (error.response && error.response.status === 422) {
                    portalContentAndDesignStore.loginFormErrors.validationErrors = error.response?.data?.errors;
                } else {
                    console.log('Login error:', error.response);
                    portalContentAndDesignStore.loginFormErrors.responseError = error.response?.data?.error || 'An error occurred. See console for details.';
                }
            })
            .finally(() => {
                portalContentAndDesignStore.loggingInProgress = false;
            });
        };

    const otpLogin = () => {
        resetLoginErrors();
        portalContentAndDesignStore.loggingInProgress = true;

        axios.post(route('partners_int.portal-login.otp.login'), {
            otp_identifier: portalContentAndDesignStore.loginFormData.email,
            otp_token: portalContentAndDesignStore.loginFormData.token,
        }).then(response => {
            if (+response.data.status === 1) {
                resetLoginErrors();
                window.location.href = response.data.redirect_url;
            } else {
                portalContentAndDesignStore.loginFormErrors.responseError = response.data?.error;
                portalContentAndDesignStore.loginFormData.token = '';
                document.getElementById('token')?.focus();
            }
        }).catch(error => {
            if (error.response && error.response.status === 422) {
                portalContentAndDesignStore.loginFormErrors.validationErrors = error.response?.data?.errors;
            } else {
                console.log('Login error:', error.response);
                portalContentAndDesignStore.loginFormErrors.responseError = error.response?.data?.error || 'An error occurred. See console for details.';
            }

        })
        .finally(() => {
            portalContentAndDesignStore.loggingInProgress = false;
        });
    };

    const submitLogin = () => {
        if (portalContentAndDesignStore.isPreview) {
            return;
        }
        const loginData = portalContentAndDesignStore.loginFormData;

        if (recaptchaEnabled.value) {
            grecaptcha.ready(() => {
                grecaptcha.execute(recaptchaKey.value, { action: 'login' }).then(token => {
                    if (portalContentAndDesignStore.loginPageSettings.is_otp_login) {
                        if (loginData.otpIdentifier && loginData.otpIniSuccessMessage) {
                            otpLogin(token);
                        } else {
                            initOtp(token);
                        }
                    } else {
                        standardLogin(token);
                    }
                });
            });
        } else {
            if (portalContentAndDesignStore.loginPageSettings.is_otp_login) {
                if (loginData.otpIdentifier && loginData.otpIniSuccessMessage) {
                    otpLogin();
                } else {
                    initOtp();
                }
            } else {
                standardLogin();
            }
        }
    };

    return {
        submitLogin,
        initOtp,
        otpLogin,
        standardLogin,
    };
}
